export type PDatePickerFastChoiceItem = {
  type: PDatePickerFastChoice
  name: string
}

export enum PDatePickerFastChoice {
  YESTERDAY = 'yesterday',
  TODAY = 'today',
  TOMORROW = 'tomorrow',
  MONDAY_OF_LAST_WEEK = 'monday-of-last-week',
  MONDAY_OF_THIS_WEEK = 'monday-of-this-week',
  MONDAY_OF_NEXT_WEEK = 'monday-of-next-week',
  FIRST_OF_LAST_MONTH = 'first-of-last-month',
  FIRST_OF_THIS_MONTH = 'first-of-this-month',
  FIRST_OF_NEXT_MONTH = 'first-of-next-month',
  FIRST_OF_LAST_YEAR = 'first-of-last-year',
  FIRST_OF_THIS_YEAR = 'first-of-this-year',
  FIRST_OF_JANUARY = 'first-of-january',
  FIRST_OF_FEBRUARY = 'first-of-february',
  FIRST_OF_MARCH = 'first-of-march',
  FIRST_OF_APRIL = 'first-of-april',
  FIRST_OF_MAY = 'first-of-may',
  FIRST_OF_JUNE = 'first-of-june',
  FIRST_OF_JULY = 'first-of-july',
  FIRST_OF_AUGUST = 'first-of-august',
  FIRST_OF_SEPTEMBER = 'first-of-september',
  FIRST_OF_OCTOBER = 'first-of-october',
  FIRST_OF_NOVEMBER = 'first-of-november',
  FIRST_OF_DECEMBER = 'first-of-december',
  IN_A_WEEK = 'in-a-week',
  IN_TWO_WEEKS = 'in-two-weeks',
  IN_A_MONTH = 'in-a-month',
  IN_HALF_A_YEAR = 'in-half-a-year',
  IN_A_YEAR = 'in-a-year',
}
